// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"bfi_a bhs_pw bhs_a bhs_w bhs_j bhs_q","LoadError__icon":"bfi_b bhs_uf bhs_fg bhs_rq","LoadError__message":"bfi_c bhs_fg bhs_sl"};